// Utility functions and type guards for file operations

export type FileWithServerPreview = File & {
  __imageId?: string;
  __previewUrl?: string;
};

export const formatAllowedFormats = (formats: string[]): string => {
  return formats.join("، ");
};

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} بایت`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} کیلوبایت`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} مگابایت`;
};

// Type guards
export const isFile = (value: unknown): value is File => {
  return value instanceof File;
};

export const isFileArray = (value: unknown): value is File[] => {
  return (
    Array.isArray(value) &&
    value.length > 0 &&
    value.every((item) => isFile(item))
  );
};

export const getServerPreviewUrl = (file: File): string | undefined => {
  return (file as FileWithServerPreview).__previewUrl;
};

export const revokeObjectUrl = (url: string | undefined): void => {
  if (url?.startsWith("blob:")) {
    URL.revokeObjectURL(url);
  }
};

// Check if a file is an image file based on MIME type or extension
export const isImageFile = (file: File): boolean => {
  // Check MIME type first
  if (file.type.startsWith("image/")) {
    return true;
  }

  // Fallback to extension check
  const extension = file.name.split(".").pop()?.toLowerCase();
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];
  return extension ? imageExtensions.includes(extension) : false;
};
